import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RsvpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rsvp"}/>
}
